import clsx from 'clsx'
import Button from '~/components/elements/Button'
import Content from '~/components/elements/Content'
import type { Page_Flexcontent_Flex_Content } from '~/graphql/types'

export default function ContentDefault({ fields }: { fields: Page_Flexcontent_Flex_Content }) {
  return (
    <section data-component="ContentDefault" className={clsx(fields?.gradientbg && 'bg-gradient-to-b from-site-light to-white', 'section')}>
      <div className="container">
        {fields?.description && <Content className={clsx(fields?.alignment === 'center' && 'mx-auto')}>{fields?.description}</Content>}

        {fields.links && (
          <div className="flex flex-wrap items-center gap-2 mt-4">
            {fields.links.map((link, index) => (
              <Button className="odd:btn-default even:btn-light" key={index} to={link?.link?.url || '/'}>
                {link?.link?.title}
              </Button>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}
